export const ConvertToPDF = {
  "Title": "Converting To PDF",
  "OfficeExcel": "Microsoft Office Excel",
  "OfficePowerPoint": "Microsoft Office PowerPoint",
  "OfficeVisio": "Microsoft Office Visio",
  "OfficeWord": "Microsoft Office Word",
  "SettingsFor": "Foxit PDF Editor Settings for {title}",
  "SettingsTitle": "Foxit PDF Editor Settings: ",
  "HighQualityPrint": "High Quality Print",
  "PDFA1b": "PDF/A-1b",
  "SmallestFileSize": "Smallest File Size",
  "Standard": "Standard",
  "USPTO": "USPTO",
  "Edit": "Edit",
  "AddBookmarks": "Add bookmarks to Foxit PDF Editor file",
  "TaggedPDF": "Tagged PDF",
  "ConvertEntireExcelWorkbook": "Convert entire Excel workbook",
  "Settings": {
    "InputName": "Please input name",
    "Unit": {
      "Inch": "Inch",
      "Centimeter": "Centimeter",
      "Millimeter": "Millimeter",
      "In": "in",
      "Cm": "cm",
      "Mm": "mm"
    },
    "Description": {
      "HighQualityPrint": "These settings are suitable for high quality print but with relatively large file size.",
      "PDFA1b": "These settings are used to create PDF files in compliance with PDF/A-1b standard.",
      "SmallestFileSize": "These settings are suitable for creating PDF files used for web distribution.",
      "Standard": "These settings have been optimized to balance print quality and file size.",
      "USPTO": "These settings are used to create Foxit PDF documents suitable for submission to United States Patent and Trademark Office."
    },
    "General": {
      "Title": "General",
      "Description": "Description",
      "FileOptions": {
        "Label": "File Options",
        "Optimize": "Optimize for fast web view",
        "Compatible": {
          "Label": "Compatible With",
          "DefaultOption": "Default"
        }
      }
    },
    "PDFStandards": {
      "Title": "PDF Standards",
      "ComplianceStandard": {
        "Title": "Compliance Standard",
        "None": {
          "Label": "None",
          "Value": "0",
          "Description": "The specified standard for saving is not set. You can choose the PDFA option you want."
        },
        "Standard1": {
          "Label": "PDF/A-1b",
          "Description": "PDF/A-1b is suitable for archiving PDF 1.3 or 1.4 files whose content structure is not accessible."
        },
        "Standard3": {
          "Label": "PDF/A-2b",
          "Description": "PDF/A-2b is suitable for archiving PDF files up to version 1.7 whose content structure is not accessible and whose text cannot be mapped to Unicode."
        },
        "Standard4": {
          "Label": "PDF/A-2u",
          "Description": "PDF/A-2u is suitable for archiving PDF files up to version 1.7 whose content structure is not accessible but whose text can be mapped to Unicode."
        },
        "Standard6": {
          "Label": "PDF/A-3b",
          "Description": "PDF/A-3b is similar to PDF/A-2b but allows embedding of non-PDF/A files."
        },
        "Standard7": {
          "Label": "PDF/A-3u",
          "Description": "PDF/A-3u is similar to PDF/A-2u but allows embedding of non-PDF/A files."
        }
      }
    },
    "Watermarks": {
      "Title": "Watermarks",
      "AddToDocument": "Add watermarks to the document",
      "ImageWatermarks": "Image Watermarks",
      "TextWatermarks": "Text Watermarks",
      "Font": "Font",
      "Name": "Name:",
      "Size": "Size:",
      "Text": "Text",
      "Content": "Content:",
      "Image": "Image",
      "FileName": "File Name:",
      "Browse": "Browse",
      "Opacity": "Opacity:",
      "Rotation": "Rotation:",
      "Offsets": "Offsets",
      "Units": "Units:",
      "Left": "Left:",
      "Top": "Top:",
      "Preview": "Preview",
      "Scale": "Scale"
    },
    "HeadersFooters": {
      "Title": "Headers/Footers",
      "AddToDocument": "Add Headers and Footers to the document",
      "Font": "Font",
      "Name": "Name:",
      "Size": "Size:",
      "Edit": "Edit",
      "EditHeaders": "Edit headers",
      "EditFooters": "Edit footers",
      "LeftColumn": "Left Column",
      "CenterColumn": "Center Column",
      "RightColumn": "Right Column",
      "InsertDate": "Insert Date",
      "InsertPageNumber": "Insert Page Number",
      "Offsets": "Offsets",
      "Units": "Units:",
      "Left": "Left:",
      "Right": "Right:",
      "Top": "Top:",
      "Bottom": "Bottom:",
      "Preview": "Preview"
    },
    "Security": {
      "Title": "Security",
      "Type": {
        "NoProtection": "no protection",
        "PasswordProtection": "password protection"
      },
      "Password": {
        "Title": "Password",
        "RequireUserPassword": {
          "Label": "Require a password to open the document",
          "UserPassword": "Document open password",
          "UserPassword1": "Repeat password"
        }
      },
      "Permission": {
        "Title": "Permission",
        "RequireOwnerPassword": {
          "Label": "Add document restrictions",
          "OwnerPassword": "Document restriction password",
          "OwnerPassword1": "Repeat password"
        }
      },
      "PermissionSpecification": {
        "Title": "Permission Specification",
        "Print": {
          "Label": "Printing Allowed",
          "Default": "None",
          "LowQualityPrint": "Low Resolution (150 dpi)",
          "HighQualityPrint": "High Resolution"
        },
        "Change": {
          "Label": "Changes Allowed",
          "Default": "None",
          "Opt1": "Filling in forms and signing existing signature fields",
          "Opt2": "Commenting, filling form, signing existing signature fields",
          "Opt3": "Inserting, deleting, and rotating pages",
          "Opt4": "Any except extracting pages"
        },
        "Copy": "Enable copying of text, image and other content",
        "Accessibility": "Enable text access for screen reader device for the visually impaired"
      },
      "ProtectionSetting": {
        "Title": "Protection Setting",
        "ProtectionAlgorithm": {
          "Label": "Protection Algorithm",
          "Opt1": "128-bit AES",
          "Opt2": "128-bit ARC-FOUR"
        },
        "IsEncrypt": "Don't encrypt metadata"
      },
      "Errors": {
        "NoneProtection": "Please complete the settings before encrypting files.",
        "EmptyOpenPassword": "Please enter open password",
        "EmptyPermissionPassword": "Please enter permission password",
        "PasswordDoesNotMatch": "Passwords entered does not match.",
        "Title": "Foxit PDF Setting",
        "ConfirmButtonText": "OK"
      }
    },
    "Edit": "Edit Settings",
    "SaveAs": "Save As..."
  }
}
